import Http from '@/utils/http/index';

export default {
  /**
   * VA 交易查询列表
   */
  getVaTransactionList(params) {
    return Http.get('/merchantVaApply/payinList', { params });
  },

  /**
   * VA 交易列表下载
   */
  downloadVaTransaction(params) {
    return Http.get('/merchantVaApply/merchantDownloadBill', { params });
  },

  /**
   * VA 交易详情查询
   */
  getTransactionDetails(id) {
    return Http.get(`/merchantVaApply/${id}/detail`);
  },
};
